import UpdateDestinationUrlForm from './UpdateDestinationUrlForm';

export default UpdateDestinationUrlForm;
